"use strict";

(function ($) {

    // TODO Youtube Iframe
    $('.youtubeiFrame').on('click', function () {
      if($(this).data('iframeurl')){
        $(this).find('img').remove();
        $(this).append('<iframe src="' + $(this).data('iframeurl') + '" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="width: 100%;height: 300px;"> </iframe>');
      }
    });

    // TODO FAQ Sorting Functionality
    $('.filter-buttons button').on('click', function(e){
        e.preventDefault();
        let term = $(this).data('filter');
        if(term === 'all') {
            $('#filter-list > div').css('display', 'inline-block');
        } else {
            $('#filter-list > div').hide();
            $('#filter-list > div').filter(function() {
                let states = $(this).data('filter').split(' ');
                return states.indexOf(term) !== -1;
            }).css('display', 'inline-block');
        }
    });

    // TODO Filter Category for FAQs
    $('body').on("click", function () {
        $(".filter-select-search").removeClass("btn-active");
        $(".filter-select-main").hide();
    });

    $(".filter-select").on("click", function (event) {
        event.stopPropagation();
    });

    $("[data-search]")
        .on("keyup", function () {
            const $wrap = $(this).closest(".filter-select");
            const searchVal = String($(this).val() || "")
                .trim()
                .toLowerCase();
            const $filterItems = $wrap.find("[data-filter-item]");

            if (searchVal !== "") {
                $filterItems.addClass("hidden");
                const $matches = $wrap.find(
                    '[data-filter-item][data-filter-name*="' + searchVal + '"]'
                );
                $matches.each(function () {
                    const $li = $(this);
                    $li.removeClass("hidden");
                    $li.parents("[data-filter-item]").removeClass("hidden");
                });
            } else {
                $filterItems.removeClass("hidden");
            }
        })
        .on("focus", function () {
            const $wrap = $(this).closest(".filter-select");
            $(".filter-select-search").removeClass("btn-active");
            $(".filter-select-main").hide();
            $wrap.find(".filter-select-search").addClass("btn-active");
            $wrap.find(".filter-select-main").slideDown(700);
        });

    // TODO Redirect Thanks Page
    document.addEventListener( 'wpcf7mailsent', function( event ) {
        window.location.href = '/thank-you/';
    }, false);
  
    // TODO Scroll To ID
    $(document).on('click', 'a[href^=\\#]', function(e){
        let el = $($(this).attr('href'));
        if(el.length && el.offset()) { // one of those may be unnecessary
            e.preventDefault();
        $('html, body').animate({
            scrollTop: el.offset().top - $('header').height() - 100
           }, 500);
        }
    });

    // TODO Menu mobile
    $('button.burger').on('click', function () {
        $('body').toggleClass('overflowGlobal');
        $('.header-nav').toggleClass('active');
        $(this).toggleClass('burger-active');
    });

    // TODO Add functionality for the mobile menu open
    $('.header .genesis-nav-menu > ul > .menu-item-has-children').on('click', function () {
        if($('.header').hasClass('header-mobile')) {
            $(this).toggleClass('open').children().last().slideToggle(150);
        } else {
            $(this).toggleClass('open');
        }
    });

    $('.header .genesis-nav-menu > ul > .menu-item-has-children .menu-item-has-children').on('click', function (event) {
        event.stopPropagation();
        if($('.header').hasClass('header-mobile')) {
            $(this).toggleClass('open').children().last().slideToggle(150);
        } else {
            $(this).toggleClass('open');
        }
    });

    // TODO Header active class, CTA on mobile and btn up fixed elements
    let lastScrollTop = 0;
    function menuFixed() {
        // Header Active Class
        if ($(window).scrollTop() > 20) {
            $('.header').addClass('header-active');
        } else {
            $('.header').removeClass('header-active');
        }
        // CTA on mobile show/hide
        let st = $(this).scrollTop();
        let header = $('header.header');
        if(header.hasClass('header-mobile')) {
            if($(window).scrollTop() > 350) {
                if (st >= lastScrollTop){
                    header.addClass('header-scroll');
                } else {
                    header.removeClass('header-scroll')
                }
            }
            lastScrollTop = st;
        }
        // Btn Up Active Show/Hide
        if ($(this).scrollTop() > 500) {
            $('#scrollToTop').addClass('btn-up-active');
        } else {
            $('#scrollToTop').removeClass('btn-up-active');
        }
    }

    $(window).bind('scroll', menuFixed);

    // TODO scroll body to 0px on click
    $('#scrollToTop').on('click', function (event) {
        event.preventDefault();
        $('body,html').animate({
            scrollTop: 0
        }, 700);
        $(this).removeClass('btn-up-active');
    });

    // TODO HD Modal
    $('.open-hd-modal').on('click', function () {
        let hdModalContentType = $(this).data('hd-modal-content-type');
        let hdModalContent = $(this).data('hd-modal-content');
        let hdModalHTML = '<div class="hd-modal">';
        let hdContainer = $('#hd-modal-container .modal-container-video');
        hdModalHTML +=
            '<div class="hd-modal-close">' +
            '<svg clip-rule="evenodd" width="24" height="24" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m12 10.93 5.719-5.72c.146-.146.339-.219.531-.219.404 0 .75.324.75.749 0 .193-.073.385-.219.532l-5.72 5.719 5.719 5.719c.147.147.22.339.22.531 0 .427-.349.75-.75.75-.192 0-.385-.073-.531-.219l-5.719-5.719-5.719 5.719c-.146.146-.339.219-.531.219-.401 0-.75-.323-.75-.75 0-.192.073-.384.22-.531l5.719-5.719-5.72-5.719c-.146-.147-.219-.339-.219-.532 0-.425.346-.749.75-.749.192 0 .385.073.531.219z" fill="#fff"/></svg></div>';

        if (hdModalContentType === 'youtube') {
            hdModalHTML =
                hdModalHTML +
                '<div class="hd-modal-before"><iframe src="https://www.youtube.com/embed/' +
                hdModalContent +
                '?autoplay=1&mute=1" allow="autoplay" allowfullscreen></iframe></div>';
        }
        if (hdModalContentType === 'file') {
            hdModalHTML =
                hdModalHTML +
                '<div class="hd-modal-before"><iframe src="' +
                hdModalContent +
                '?autoplay=1&mute=1" allow="autoplay" allowfullscreen></iframe></div>';
        } else if (hdModalContentType === 'wistia') {
            hdModalHTML += `<div class="hd-modal-before"><iframe src="https://fast.wistia.net/embed/iframe/${hdModalContent}" allowfullscreen frameborder="0" scrolling="no" class="wistia_embed" name="wistia_embed" allow="autoplay; fullscreen" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: none;"></iframe></div><script src="https://fast.wistia.com/embed/medias/${hdModalContent}.jsonp" async></script><script src="https://fast.wistia.com/assets/external/E-v1.js" async></script>`;
        } else {
            hdModalHTML = hdModalHTML + hdModalContent;
        }
        hdContainer.append(hdModalHTML);
        $('.modal-container').addClass('active');
    });

    $(document).on('click', '.hd-modal-close, #hd-modal-container', function (e) {
        if (
            ($(this).is('#hd-modal-container') && !$(e.target).closest('.hd-modal').length) ||
            $(this).hasClass('hd-modal-close')
        ) {
            $('.modal-container').removeClass('active');
            $('#hd-modal-container .modal-container-video').empty();
        }
    });

    // TODO Table of content
    $(".blogSidebar .contents").on("click", function () {
        $(this).toggleClass("active");
        $('.contents-wrap').slideToggle(500);
        if ($(this).hasClass("active")) {
            $(".js-fix").text("Close");
        } else {
            $(".js-fix").text("Expand");
        }
    });

    // TODO Accordion Mobile
    $(".accordion-header").on("click", function () {
        if ($(this).hasClass("active")) {
            $(this).removeClass("active").next().slideUp(500);
            return false;
        }
        $(".accordion-header").removeClass("active").next().slideUp(500);
        $(this).addClass("active").next().slideDown(500);
    });

})(jQuery);

// ============================================================
// Hero Results
// ============================================================
(function ($) {
    $('.hp-new-slider .slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        autoplay: false,
        dots: false,
        swipeToSlide: true,
        arrows: true,
        speed: 600,
        appendArrows: $('.hp-new-slider').find('.arrow'),

        // 👇 Updated Arrows
        prevArrow: `
      <button class="custom-prev" aria-label="Previous">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
          xmlns="http://www.w3.org/2000/svg" style="transform: rotate(180deg);">
          <path d="M19.25 24L27.25 16M27.25 16L19.25 8M27.25 16H5.25"
            stroke="#081725" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    `,

        nextArrow: `
      <button class="custom-next" aria-label="Next">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path d="M19.25 24L27.25 16M27.25 16L19.25 8M27.25 16H5.25"
            stroke="#081725" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    `,

        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    variableWidth: true,
                    slidesToShow: 1,
                }
            }
        ]
    });

    // Initialize Slick
    $('.hp-static').slick({
        slidesPerRow: 1,
        rows: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 300,
        vertical: true,
        verticalSwiping: true,
        swipeToSlide: true,
        arrows: false,
        dots: false,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesPerRow: 1,
                    rows: 2
                }
            }
        ]
    });
})(jQuery);

// ============================================================
// Logo Marquee Slider
// ============================================================
function createMarquee(wrapperSelector, contentSelector, options = {}) {
    const marqueeWrapper = document.querySelector(wrapperSelector);
    const marqueeContent = document.querySelector(contentSelector);

    if (!marqueeWrapper || !marqueeContent) return;

    const originalContent = marqueeContent.innerHTML;
    marqueeContent.innerHTML = '';

    const innerContainer = document.createElement('div');
    innerContainer.className = 'marquee-inner-container';
    innerContainer.style.cssText = 'display:flex;position:relative;width:max-content;';

    const content1 = document.createElement('div');
    content1.className = 'marquee-content-block d-flex';
    content1.innerHTML = originalContent;

    const content2 = document.createElement('div');
    content2.className = 'marquee-content-block d-flex';
    content2.innerHTML = originalContent;

    innerContainer.appendChild(content1);
    innerContainer.appendChild(content2);
    marqueeContent.appendChild(innerContainer);

    marqueeWrapper.style.overflow = 'hidden';
    marqueeWrapper.style.position = 'relative';

    const speed = options.speed || 1;
    let animationFrame;
    let scrollPosition = 0;
    let contentBlockWidth = content1.offsetWidth;

    setTimeout(() => {
        contentBlockWidth = content1.offsetWidth;
        animate();
    }, 50);

    function animate() {
        scrollPosition -= speed;
        if (Math.abs(scrollPosition) >= contentBlockWidth) {
            scrollPosition = 0;
        }
        innerContainer.style.transform = `translateX(${scrollPosition}px)`;
        animationFrame = requestAnimationFrame(animate);
    }

    function handleResize() {
        content1.innerHTML = originalContent;
        content2.innerHTML = originalContent;
        contentBlockWidth = content1.offsetWidth;
    }

    window.addEventListener('resize', handleResize);
    window.addEventListener('unload', () => cancelAnimationFrame(animationFrame));
}

document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.logo-slider-wrapper')) {
        createMarquee('.logo-slider-wrapper', '.logo-slider', { speed: 1 });
    }
});

// ============================================================
// Static Slider (Slick)
// ============================================================
(function ($) {
    const $slider = $('.cmn-static-slider');
    if (!$slider.length) return;

    function equalizeSlickHeights(slider) {
        let maxH = 0;
        slider.find('.slick-slide').css('height', 'auto');
        slider.find('.slick-slide').each(function () {
            const h = $(this).outerHeight();
            if (h > maxH) maxH = h;
        });
        slider.find('.slick-slide').css('height', maxH);
    }

    $slider.on('init setPosition', function () {
        equalizeSlickHeights($slider);
    });

    $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        dots: true,
        vertical: true,
        verticalSwiping: true,
        swipeToSlide: true,
        arrows: false,
        autoplaySpeed: 1500,
        speed: 300,
    });

    $(window).on('resize', function () {
        equalizeSlickHeights($slider);
    });
})(jQuery);

// ============================================================
// Video Slider (Slick) + Modal
// ============================================================
(function ($) {
    if (!$('.cmn-video-slider .slider').length) return;

    const arrowPrev = `
        <button class="custom-prev" aria-label="Previous">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform:rotate(180deg);">
                <path d="M19.25 24L27.25 16M27.25 16L19.25 8M27.25 16H5.25" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>`;

    const arrowNext = `
        <button class="custom-next" aria-label="Next">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.25 24L27.25 16M27.25 16L19.25 8M27.25 16H5.25" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>`;

    const $videoSlider = $('.cmn-video-slider .slider');
    const videoSlideCount = $videoSlider.children().length;

    $videoSlider.slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
        autoplay: false,
        dots: false,
        swipeToSlide: true,
        initialSlide: videoSlideCount >= 4 ? 1 : 0,
        variableWidth: true,
        arrows: true,
        speed: 600,
        appendArrows: $('.cmn-video-slider').find('.arrow'),
        prevArrow: arrowPrev,
        nextArrow: arrowNext,
        responsive: [
            { breakpoint: 1199, settings: { slidesToShow: 1, slidesToScroll: 1 } },
            { breakpoint: 576, settings: { variableWidth: false, slidesToShow: 1, slidesToScroll: 1 } }
        ]
    });
})(jQuery);

// ============================================================
// Testimonials Slider (Slick) + Modal
// ============================================================
(function ($) {
    if (!$('.cmn-testimonials .slider').length) return;

    const arrowPrev = `
        <button class="custom-prev" aria-label="Previous">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform:rotate(180deg);">
                <path d="M19.25 24L27.25 16M27.25 16L19.25 8M27.25 16H5.25" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>`;

    const arrowNext = `
        <button class="custom-next" aria-label="Next">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.25 24L27.25 16M27.25 16L19.25 8M27.25 16H5.25" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>`;

    const $testimonialsSlider = $('.cmn-testimonials .slider');
    const testimonialsSlideCount = $testimonialsSlider.children().length;

    $testimonialsSlider.slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
        autoplay: false,
        dots: false,
        swipeToSlide: true,
        initialSlide: testimonialsSlideCount >= 4 ? 1 : 0,
        variableWidth: true,
        arrows: true,
        speed: 600,
        appendArrows: $('.cmn-testimonials').find('.arrow'),
        prevArrow: arrowPrev,
        nextArrow: arrowNext,
        responsive: [
            { breakpoint: 1199, settings: { slidesToShow: 1, slidesToScroll: 1 } },
            { breakpoint: 576, settings: { variableWidth: false, slidesToShow: 1, slidesToScroll: 1 } }
        ]
    });
})(jQuery);

// ============================================================
// Fix lazy-load: data-src → src
// ============================================================
(function ($) {
    $(document).ready(function () {
        $('[data-src]').each(function () {
            $(this).attr('src', $(this).attr('data-src')).removeAttr('data-src');
        });
    });
})(jQuery);